import { useEffect, useState } from "react";
import styled from "styled-components";
import { Graph } from "../../components/Graph";
import { Colors, Text } from "../../config/Constants";
import { DashboardCard } from "./DashboardCard";
import { getDashboardData } from "../../services/adminService";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import { useLoadContext } from "../../contexts/LoadContext";
import PieChart from "../../components/PieChart";
import { getFormattedPieData } from "../../helper";

const Home = () => {
  const [cardData, setCardData] = useState({
    totalCustomers: 0,
    totalMerchants: 0,
    alMahaDrive: 0,
  });
  const [graphData, setGraphData] = useState([]);
  const [pieChartData, setPieData] = useState({});
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });
  const { setLoader } = useLoadContext();

  const fetchDashboardDetails = async (date: string) => {
    setLoader(true);
    try {
      const res = await getDashboardData(date);
      if (res.status === 200) {
        setCardData({
          totalCustomers: res.data.data.totalCustomers,
          totalMerchants: res.data.data.totalMerchants,
          alMahaDrive: res.data.data.alMahaDrive,
        });
        setGraphData(res.data.data.outlets);
        setPieData(
          getFormattedPieData(res.data.data.reservationCountData.data)
        );
      }
    } catch (error: any) {
      if (navigator.onLine) {
        setIsError(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
    setLoader(false);
  };

  useEffect(() => {
    fetchDashboardDetails("today");
  }, []); // eslint-disable-line

  const [activeTab, setTab] = useState(1);
  const handleTab = (val: number) => {
    const searchDateArray = ["today", "yesterday", "week"];
    setTab(val);
    fetchDashboardDetails(searchDateArray[val - 1]);
  };
  return (
    <PageWrapper>
      <PageText>{Text.dashboardText}</PageText>
      <WelcomeText>{Text.welcomeText}</WelcomeText>
      <DashboardCard dashboardData={cardData} />
      {pieChartData && (
        <div>
          <PieChart
            activeTab={activeTab}
            onHandleSelect={(val) => handleTab(val)}
            chartData={pieChartData}
          />
        </div>
      )}
      {graphData.length !== 0 && <Graph dashboardGraphArray={graphData} />}
      {isError && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setIsError}
          onSubmit={() => setIsError(false)}
        />
      )}
    </PageWrapper>
  );
};
const PageWrapper = styled.div`
  @media only screen and (max-width: 768px) {
    padding: 1.5rem;
  }
`;
const PageText = styled.div`
  color: ${Colors.black};
  font-style: normal;
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-family: "Poppins-Medium";
  font-weight: 500;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const WelcomeText = styled.div`
  color: ${Colors.secondaryBlack};
  font-size: 2.5rem;
  font-style: normal;
  line-height: 1.75rem;
  margin-top: 2.5rem;
  font-family: "Poppins-Light";
  font-weight: 300;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;
export default Home;
